import { useMutation } from '@tanstack/react-query';
import { useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';

import Api from '@barboxx/api';
import { Substitution } from '@barboxx/models';
import { useBool } from '@barboxx/react-utils';

interface Props {
    substitution: Substitution;
}

export const SubstitutionDeleteCard = ({ substitution }: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const [open, dialogActions] = useBool();

    const mutateDeleteSubstitution = useMutation({
        mutationKey: ['deleteSubstitution', substitution.id],
        mutationFn: () =>
            Api.Core.Substitution.deleteSubstitution(substitution),
    });

    const onDelete = async () => {
        mutateDeleteSubstitution
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted substitution!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notifications.show('Error Deleting substitution!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete Substitution" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this substitution?
                    </Typography>

                    <Button
                        onClick={dialogActions.on}
                        color="error"
                        variant="outlined"
                    >
                        Delete
                    </Button>
                </Stack>
            </CardContent>
            <Dialog
                open={open}
                onClose={dialogActions.off}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Delete Alcohol
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to Delete this substitution?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={dialogActions.off} color="inherit">
                        Cancel
                    </Button>

                    <Button
                        onClick={onDelete}
                        color="error"
                        variant="contained"
                        loading={mutateDeleteSubstitution.isPending}
                        autoFocus
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Card>
    );
};
